import initialState from './initialState'
import * as types from '../actions/actionTypes'

const initialFriendsState = []
initialFriendsState.initialState = true // Mark as not yet loaded.
export function friends(state = initialFriendsState, action) {
  switch (action.type) {
    case types.GET_FRIENDS:
      return action.payload;
    case types.ADD_FRIEND:
      const hasMindfile = state.find((mindfile) => {
        return mindfile.id === action.payload.id
      })
      return !hasMindfile ? [...state, action.payload] : state;
    case types.REMOVE_FRIEND:
      const targetMindfile = action.payload
      return state.filter((mindfile) => {
        return mindfile.id !== targetMindfile.id
      });
    default:
      return state;
  }
}

export function mindfile(state = initialState, action) {
  switch (action.type) {
    case types.LOADING_MINDFILE:
      return Object.assign({}, state, {
        loading: action.payload,
      })
    case types.GET_MINDFILE:
      return action.payload;
    case types.UPDATE_MINDFILE_NAME:
    // TODO: test changing bot_name, does it break avatar?
      return Object.assign({}, state, {
        name: action.payload,
        bot_name: action.payload,
      })
    case types.UPDATE_BIRTHDAY:
      return {...state, birthday: action.payload}
    case types.UPDATE_LOCATION:
      const oldLocation = state.location || {}
      return Object.assign({}, state, {
        location: Object.assign({}, oldLocation, action.payload)
      })
    case types.UPDATE_MINDFILE_PRIVACY_LEVEL:
      return Object.assign({}, state, {
        privacy_level: action.payload,
      })
    case types.UPDATE_MINDFILE_GROUP:
      return Object.assign({}, state, {
        group: action.payload,
      })
    case types.GET_MINDFILE_PHOTOS:
      return Object.assign({}, state, {
        photos: action.payload,
      })
    case types.SET_MINDFILE_PICTURE_UPLOADING:
      // Update the count:
      return Object.assign({}, state, {
        timestamp: Math.floor(new Date().getTime()/1000),
        picturesUploading: Math.max(0, state.picturesUploading + (action.payload ? 1 : -1)),
      })
    case types.LOG_OUT:
      return {}
    default:
      return state
  }
}

export function mindfiles(state = [], action) {
  if (action.type === types.GET_CURRENT_USER_MINDFILES) {
    return action.payload;
  }
  return state;
}

export function isCurrentMindfileOwner(state = false, action) {
  if (action.type === types.GET_MINDFILE) {
    return (action.payload.owner === action.payload.loggedInUid);
  } else {
    return state;
  }
}

export function isCurrentMindfileContributor(state = false, action) {
  if (action.type === types.GET_MINDFILE) {
    const contributors = action.payload.contributors || [];
    const contributorIds = contributors.map(contributor => contributor.id);
    return (contributorIds.includes(action.payload.loggedInUid));
  } else {
    return state;
  }
}

export function mindfileUserLevel(state = {level: 3, admin: false}, action) {
  if (action.type === types.LOG_IN) {
    return {...state, admin: action.payload.is_admin};
  }else if (action.type === types.GET_MINDFILE) {
    if(action.payload.owner === action.payload.loggedInUid){
      return {...state, level: 1};
    }
    const contributors = action.payload.contributors || [];
    const contributorIds = contributors.map(contributor => contributor.id);
    if(contributorIds.includes(action.payload.loggedInUid)){
      return {...state, level: 2};
    }
    return {...state, level: 3};
  }
  return state;
}

export function viewItem(state = null, action) {
  switch (action.type) {
    case types.GET_MINDFILE_ITEM:
      return action.payload;
    case types.UPDATE_MINDFILE_ITEM:
      return !!state && action.payload.id !== state.id ? state : {
          ...state,
          ...action.payload,
          item_data: {...state?.item_data, ...action.payload.item_data}
        };
    case types.GET_MINDFILE_ITEMS:
      if(!action.payload || state === null || !state.id){
        return state;
      }
      const newItem = action.payload.find(item => item.id === state.id);
      if(!newItem){
        return state;
      }
      if(newItem.url_ts > state.url_ts){
        return newItem;
      }
      return state;
    case types.GET_MINDFILE_ITEM_DETAILS:
      if(!action.payload || state === null || !state.id){
        return state;
      }
      const newDetails = action.payload.find(item => item.id === state.id);
      if(!newDetails){
        return state;
      }
      if(newDetails.url_ts > state.url_ts){
        const url = `/mindfiles/${state.mindfile_id}/show/${state.item_data_id}/${state.url_show_hash}/thumbnail?ts=${newDetails.url_ts}`
        return {...state, url_ts: newDetails.url_ts, updated_at: newDetails.updated_at, item_data:{...state.item_data, conversion: newDetails.conversion}, thumbnail_url:url}
      }
      return state;
    default:
      return state;
  }
}

export function folderList(state = [], action) {
  const stateArray = state || []
  switch (action.type) {
    case types.GET_FOLDER_LIST:
      return action.payload
    case types.ADD_FOLDER:
      return [action.payload].concat(stateArray);
    case types.REMOVE_FOLDER:
      return stateArray.slice(0, action.payload).concat(stateArray.slice(action.payload + 1));
    case types.REMOVE_FOLDERS:
      if(!action.payload || action.payload.length === 0 || state === null || state.length ===0){
        return state;
      }
      return state.filter(f => !action.payload.find(r => r === f.id.toString()));
    case types.UPDATE_FOLDERS:
      let updated = [...action.payload];
      const newFolders = [];
      const oldFolders = [];
      state.forEach((f) => {
        const remI = updated.findIndex(u => u.id === f.id);
        if(remI >= 0){
          newFolders.push(updated[remI]);
          // updated = [...updated.slice(0,remI), ...updated.slice(remI + 1)];
        }else{
          oldFolders.push(f);
        }
      });
      return [...newFolders, ...oldFolders];
    case types.GET_FOLDER_DETAILS:
      const index = state.findIndex(u => u.id === action.payload.id);
      if(index < 0){
        return state;
      }
      const prev = state[index];
      if(action.payload.updated_at === prev.updated_at){
        return state;
      }
      return [action.payload, ...state.filter(f => f.id !== action.payload.id)];
    default:
      return state;
  }
}

export function folders(state = {}, action) {
  if(!state.folders && action.type !== types.GET_FOLDERS){
    return state;
  }
  switch (action.type) {
    case types.GET_FOLDERS:
      return action.payload
    case types.ADD_FOLDER:
      return {
        folders: [action.payload, ...state.folders],
        folder_count: state.folder_count + 1,
        filter_count: state.filter_count + 1
      };
    case types.REMOVE_FOLDER:
      return {
        folders: [...state.folders.filter(f => f.id !== action.payload)],
        folder_count: state.folder_count - 1,
        filter_count: state.filter_count - 1
      };
    case types.REMOVE_FOLDERS:
      let remove = [...action.payload];
      let count = 0;
      const folders = [];
      state.folders.forEach((f) => {
        const remI = remove.findIndex(i => i === f.id.toString());
        if(remI >= 0){
          // remove = [...remove.slice(0,remI), ...remove.slice(remI + 1)];
          count++;
        }else{
          folders.push(f);
        }
      });
      return {
        folders: folders,
        folder_count: state.folder_count - action.payload.length,
        filter_count: state.filter_count - count
      };
    case types.UPDATE_FOLDER:
      return state.map(folder => {
        if (folder.id === action.folderId) {
          return Object.assign({}, folder, {name: action.name, description: action.description});
        } else {
          return folder;
        }
      });
    case types.UPDATE_FOLDERS:
      let updated = [...action.payload];
      const newFolders = [];
      state.folders.forEach((f) => {
        const remI = updated.findIndex(u => u.id === f.id);
        if(remI >= 0){
          newFolders.push(updated[remI]);
          // updated = [...updated.slice(0,remI), ...updated.slice(remI + 1)];
        }else{
          newFolders.push(f);
        }
      });
      return {
        folders: newFolders,
        folder_count: state.folder_count,
        filter_count: state.filter_count
      };
    case types.GET_FOLDER_DETAILS:
      return {
        folders: [...state.folders.map((f) => f.id === action.payload.id ? action.payload : f)],
        folder_count: state.folder_count,
        filter_count: state.filter_count
      };
    default:
      return state
  }
}

export function selectedFolders(state = {}, action) {
  let changed = false;
  switch (action.type) {
    case types.SET_SELECTED_FOLDERS:
      return action.payload;
    case types.REMOVE_FOLDERS:
      if(!action.payload){
        return state;
      }
      const remItems = {...state};
      action.payload.forEach(id => {
        delete remItems[id];
      })
      return remItems;
    case types.UPDATE_FOLDERS:
    case types.GET_FOLDERS:
      if(!action.payload){
        return state;
      }
      const folders = action.type === types.GET_FOLDERS ? action.payload.folders : action.payload;
      if(!folders || !folders.forEach){
        return state;
      }
      const updatedItems = {...state};
      folders.forEach(item => {
        if(!!updatedItems[item.id]){
          updatedItems[item.id] = item;
          changed = true;
        }
      });
      return changed ? updatedItems : state;
    case types.UPDATE_FOLDER:
      if(!action.payload){
        return state;
      }
      return !!state[action.payload.id] ? {...state, [action.payload.id]:action.payload} : state;
    default:
      return state
  }
}

export function folderDetails(state = {}, action) {
  switch (action.type) {
    case types.GET_FOLDER_DETAILS:
      return action.payload
    default:
      return state
  }
}

export function mindfile_items(state = {items:[], filter_count:0}, action) {
  switch (action.type) {
    case types.GET_ITEMS:
      return action.payload
    case types.REMOVE_ITEMS:
      return {...state, items:[...state.items.filter(item => !action.payload.includes(item.id.toString()))]}
    case types.MOVE_ITEMS:
      return action.payload
    case types.GET_MINDFILE_ITEM:
    case types.UPDATE_MINDFILE_ITEM:
      if(!action.payload){
        return state;
      }
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if(index === -1){
        return state;
      }
      const newItem = action.type === types.GET_MINDFILE_ITEM
        ? action.payload
        : {
          ...state.items[index],
          ...action.payload,
          item_data: {...state.items[index].item_data, ...action.payload.item_data}
        };
      return {...state, items:[...state.items.slice(0, index), newItem, ...state.items.slice(index + 1)]}
    case types.GET_MINDFILE_ITEMS:
      if(!action.payload){
        return state;
      }
      let update = false;
      const updatedItems = [...state.items];
      action.payload.forEach(newItem => {
        let i = state.items.findIndex(item => item.id === newItem.id);
        if(i === -1){
          return;
        }
        const prev = state.items[i];
        if(newItem.url_ts > prev.url_ts){
          updatedItems[i] = newItem;
          update = true;
        }
      });
      return update ? {...state, items: updatedItems} : state;
    case types.GET_MINDFILE_ITEM_DETAILS:
      if(!action.payload){
        return state;
      }
      let changed = false;
      const newItems = [...state.items];
      action.payload.forEach(newItem => {
        let i = state.items.findIndex(item => item.id === newItem.id);
        if(i === -1){
          return;
        }
        const prev = state.items[i];
        if(newItem.url_ts > prev.url_ts || newItem.conversion !== prev.item_data.conversion){
          changed = true;
          const url = `/mindfiles/${prev.mindfile_id}/show/${prev.item_data_id}/${prev.url_show_hash}/thumbnail?ts=${newItem.url_ts}`
          newItems[i] = {...prev, url_ts: newItem.url_ts, updated_at: newItem.updated_at, item_data:{...prev.item_data, conversion: newItem.conversion}, thumbnail_url:url}
        }
      })
      return changed ? {...state, items: newItems} : state;
    default:
      return state
  }
}

export function selectedItems(state = {}, action) {
  let changed = false;
  switch (action.type) {
    case types.SET_SELECTED_MINDFILE_ITEMS:
      return action.payload;
    case types.REMOVE_ITEMS:
      const remItems = {...state};
      action.payload.forEach(id => {
        delete remItems[id];
      })
      return remItems;
    case types.GET_MINDFILE_ITEM:
    case types.UPDATE_MINDFILE_ITEM:
      if(!action.payload || !state[action.payload.id]){
        return state;
      }
      const newItem = action.type === types.GET_MINDFILE_ITEM
        ? action.payload
        : {
          ...state[action.payload.id],
          ...action.payload,
          item_data: {...state[action.payload.id].item_data, ...action.payload.item_data}
        };
      return !!state[action.payload.id] ? {...state, [action.payload.id]:newItem} : state;
    case types.GET_MINDFILE_ITEMS:
      if(!action.payload){
        return state;
      }
      const updatedItems = {...state};
      action.payload.forEach(item => {
        if(!!updatedItems[item.id] && item.url_ts > updatedItems[item.id].url_ts){
          updatedItems[item.id] = item;
          changed = true;
        }
      });
      return changed ? updatedItems : state;
    case types.GET_MINDFILE_ITEM_DETAILS:
      if(!action.payload){
        return state;
      }
      const newItems = {...state};
      action.payload.forEach(newItem => {
        const prev = state[newItem.id];
        if(!prev){
          return;
        }
        if(newItem.url_ts > prev.url_ts || newItem.conversion !== prev.item_data.conversion){
          changed = true;
          const url = `/mindfiles/${prev.mindfile_id}/show/${prev.item_data_id}/${prev.url_show_hash}/thumbnail?ts=${newItem.url_ts}`
          newItems[newItem.id] = {...prev, url_ts: newItem.url_ts, updated_at: newItem.updated_at, item_data:{...prev.item_data, conversion: newItem.conversion}, thumbnail_url:url}
        }
      })
      return changed ? newItems : state;
    default:
      return state
  }
}

export function itemLocations(state = {setId:0, locations:[]}, action) {
  let newLocations;
  switch (action.type) {
    case types.GET_ITEM_LOCATIONS:
      return action.payload;
    case types.GET_ITEM_LOCATIONS_BATCH:
      if(action.payload.setId === state.setId) {
        const state_ids = state.locations.map(l => l.location_id);
        const uniq_locs = action.payload.locations.filter(loc => !state_ids.includes(loc.location_id))
        if(uniq_locs.length === 0){
          return state;
        }
        return {setId: state.setId, locations: [...state.locations, ...uniq_locs]}
      }else if(action.payload.setId > state.setId) {
        return action.payload;
      }else{
        return state;
      }
    case types.GET_MINDFILE_ITEMS:
      newLocations = [...state.locations];
      (action.payload || []).forEach(item => {
        const newLocIndex = newLocations.findIndex(loc => loc.id === item.id);
        if(item.location) {
          if(newLocIndex === -1){
            const newLoc = {id: item.id, location_id: item.location.id, longitude: item.location.longitude, latitude: item.location.latitude}
            newLocations.push(newLoc);
          }else{
            const newLoc = newLocations[newLocIndex];
            newLoc.location_id = item.location.id;
            newLoc.longitude = item.location.longitude;
            newLoc.latitude = item.location.latitude;
          }
        }else if(newLocIndex !== -1){
          newLocations = [...newLocations.slice(0,newLocIndex), ...newLocations.slice(newLocIndex+1)];
        }
      })
      return {setId: state.setId, locations: newLocations};
    case types.GET_MINDFILE_ITEM:
      if(!action.payload){
        return state;
      }
      newLocations = [...state.locations];
      const item = action.payload;
      const newLocIndex = newLocations.findIndex(loc => loc.id === item.id);
      if(item.location) {
        if(newLocIndex === -1){
          const newLoc = {id: item.id, location_id: item.location.id, longitude: item.location.longitude, latitude: item.location.latitude}
          newLocations.push(newLoc);
        }else{
          const newLoc = newLocations[newLocIndex];
          newLoc.location_id = item.location.id;
          newLoc.longitude = item.location.longitude;
          newLoc.latitude = item.location.latitude;
        }
      }else if(newLocIndex !== -1){
        newLocations = [...newLocations.slice(0,newLocIndex), ...newLocations.slice(newLocIndex+1)];
      }
      return {setId: state.setId, locations: newLocations};
    case types.REMOVE_ITEMS:
      const remIds = action.payload;
      return {setId: state.setId, locations:  [...state.locations.filter(loc => !remIds.includes(loc.id.toString()))]};
    default:
      return state
  }
}

export function userViewOpts(state={}, action) {
  switch (action.type) {
    case types.GET_USER_VIEW_OPTS:
      return {...action.payload, loaded: true};
    case types.UPDATE_PAGE_VIEW_OPTS:
      if(action.payload.view_options && Object.keys(action.payload.view_options).length > 0){
        return {...state, opts: {...state.opts, [action.payload.page]: action.payload.view_options}};
      }else{
        return {...state, opts:Object.fromEntries(Object.entries(state.opts).filter(kv => kv[0] !== action.payload.page))};
      }
    default:
      return state
  }
}

export function spacecastSettings(state = {}, action) {
  switch (action.type) {
    case types.GET_SPACECAST_SETTINGS:
    case types.UPDATE_SPACECAST_SETTINGS:
      return action.payload;
    default:
      return state;
  }
}

export function multiUserMindfiles(state = {}, action) {
  if (action.type === types.MULTI_USER_MINDFILES) {
    return action.payload;
  } else {
    return state;
  }
}

export function usageData(state = {}, action) {
  switch (action.type) {
    case types.USAGE_DATA:

      return action.payload;
    default:
      return state
  }
}

export function importSources(state = {}, action) {
  switch (action.type) {
    case types.IMPORT_SOURCES:
      return action.payload;
    default:
      return state
  }
}

export function avatarReadyAt(state = null, action) {
  if (action.type === types.SET_AVATAR_READY_AT) {
    return action.payload;
  } else {
    return state;
  }
}
